import { Control, Controller } from 'react-hook-form'

import { Checkbox, FormControlLabel, FormGroup, FormHelperText } from '@mui/material'

import { VideoMainFormValues } from '../../videoMainForm.types'

type Props = {
  control: Control<VideoMainFormValues>
}

const HELPER_TEXT =
  'Видео попадает в ленту «Последние» автоматически, если лежит в плейлисте публичного курса, который не является «Онлайн занятиями», и окно открыто (дата «Для студентов до» не задана или ещё не наступила). Отметьте, чтобы скрыть видео из ленты. Если окно закрыто — видео не покажется в любом случае.'

export const ExcludedFromRecentController = ({ control }: Props) => {
  return (
    <Controller
      control={control}
      name={'excludedFromRecent'}
      render={({ field }) => (
        <FormGroup>
          <FormControlLabel
            control={
              <Checkbox
                checked={Boolean(field.value)}
                onChange={event => field.onChange(event.target.checked)}
              />
            }
            label={'Скрыть из последних видео'}
          />

          <FormHelperText>{HELPER_TEXT}</FormHelperText>
        </FormGroup>
      )}
    />
  )
}
